import React, { useContext } from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import AuthContext from "context/AuthContext";
import helper from "../../utils/helpers";
import apiPath from "../../utils/apiPath";
import { apiPut, apiDelete } from "../../utils/apiFetch";
import { useNavigate } from 'react-router-dom'



const Table = ({ users, page, sort, setSort, manager, getAllNotification }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handelDelete = async (item) => {
      try {
        const path = apiPath.getNotification + "/" + item?._id;
        const result = await apiDelete(path);
        if (result?.status === 200) {
          getAllNotification();
        }
      } catch (error) {
        console.log("error in get all Notifications list==>>>>", error.message);
      }
    };

    
    // setCurrentItem(item)
    // setCountryEdit(!countryEdit)
  const handleEdit = item => {
    navigate('/notification_manager/edit', { state: item })
  }

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <TableHeaderCell text={t("SR_NO")} />
              <TableHeaderCell text={t("TITLE")} />
              <TableHeaderCell text={t("MESSAGE")} />
              <TableHeaderCell text={t("SEND_TO")} />
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortBy === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.edit || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {users &&
              users?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-3 px-6 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-3 px-6 border-r text-gray-900">
                    {item?.title}{" "}
                  </td>
                  <td className="py-3 px-6 border-r text-gray-900">
                    {item?.description}
                  </td>
                  <td className="py-3 px-6 border-r text-gray-900">
                    {startCase(item?.sendTo)}
                  </td>
                  <td className="py-3 px-6 border-r text-gray-900">
                    {dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}{" "}
                  </td>
                  {(manager?.edit || user?.role === "admin") && (
                    <td className="py-4 px-6 border-l text-gray-900">
                      <div className="">
                        <ul className="flex justify-center">
                          <li
                            onClick={() => handleEdit(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("FAQS_EDIT_FAQS")}>
                              {" "}
                              <AiFillEdit className="w-5 h-5 text-slate-600" />
                            </button>
                          </li>

                          {user?.role === "admin" && (
                            <li
                              onClick={(e) =>
                                helper.alertFunction(
                                  `Are you sure want to delete '${item.title}'?`,
                                  item,
                                  handelDelete,
                                  true
                                )
                              }
                              className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                            >
                              <button title={t("DELETE_NOTIFICATION")}>
                                {" "}
                                <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(users) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={5}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
